import { forwardRef } from 'react';
import styled from 'styled-components';
import MUISnackbar from '@material-ui/core/Snackbar';

const Snackbar = MUISnackbar;

Snackbar.defaultProps = {
  anchorOrigin: { vertical: 'top', horizontal: 'center' },
  autoHideDuration: 5000,
};

export default Snackbar;
